import React from "react";
import DynamicUniversityPage from "../../../custom-components/DynamicUniversityPage";
import { galgotiasUniversityJson } from "./GalgotiasUniversityJson";
import DynamicWhyChooseThisUniversitiesPage from "../../../custom-components/DynamicWhyChooseThisUniversityPage";
import UniversityKnowMore from "src/CountryPages/University/UniversityKnowMore";
import Location from "../../../custom-components/Location";
import DynamicUniversityDetails from "../../../custom-components/DynamicUniversityDetails";
import DynamicNationalitySelection from "../../../custom-components/DynamicNationalitySelection";

const GalgotiasUniversity = () => {
  const { heading, backgroundImage, content } =
    galgotiasUniversityJson.BannerData;

  return (
    <>
      <DynamicUniversityPage
        heading={heading}
        backgroundImage={backgroundImage}
        content={content}
      />
      <DynamicUniversityDetails
        data={galgotiasUniversityJson.universityDetails}
      />

      <DynamicWhyChooseThisUniversitiesPage
        rankingsData={galgotiasUniversityJson?.WhyChooseThisUniversityPage}
      />
      
       <DynamicNationalitySelection data={galgotiasUniversityJson}/>

      <Location
        header={galgotiasUniversityJson?.Location.header}
        image={galgotiasUniversityJson?.Location.image}
        content={
          galgotiasUniversityJson?.Location?.content || "No content available"
        }
      />
      <UniversityKnowMore data={galgotiasUniversityJson?.KnowMore} />
    </>
  );
};

export default GalgotiasUniversity;
